/**
 * Status tints for the widgets' icon boxes and tiles — derived from the status
 * tokens by opacity (DESIGN.md › Soft status surfaces), the icon carrying the
 * colour. Literal class strings so Tailwind sees them.
 */
export type Tone = "destructive" | "warning" | "info" | "success" | "brand" | "muted";

export const TONE_TINT: Record<Tone, string> = {
  destructive: "bg-destructive/10 text-destructive",
  warning: "bg-warning/10 text-warning",
  info: "bg-info/10 text-info",
  success: "bg-success/10 text-success",
  brand: "bg-brand/10 text-brand",
  muted: "bg-muted text-muted-foreground",
};

/** Solid fills for bar segments and legend dots. */
export const TONE_FILL: Record<Tone, string> = {
  destructive: "bg-destructive",
  warning: "bg-warning",
  info: "bg-info",
  success: "bg-success",
  brand: "bg-brand",
  muted: "bg-muted-foreground/60",
};
